import { DocumentNode } from 'graphql';
import React, { useEffect, useState } from 'react';
import { LookupModel } from 'types/graphql';
import useApolloClient from 'useApolloClient';

interface ILookupWrapperProps<TQuery, TQueryVariables, TLookup> {
  queryDocument: DocumentNode;
  queryVariables: TQueryVariables;
  selectedValues?: number[];
  extractLookups: (query: TQuery) => TLookup[];
  children: (params: {
    lookups: TLookup[];
    selectedLookups: TLookup[];
  }) => JSX.Element;
}

export const LookupWrapper = <
  TQuery,
  TQueryVariables,
  TLookup extends { id: number } = LookupModel,
>(
  props: ILookupWrapperProps<TQuery, TQueryVariables, TLookup>,
) => {
  const { client } = useApolloClient();
  const [lookups, setLookups] = useState<TLookup[]>([]);

  const fetchLookups = () => {
    client
      .query<TQuery, TQueryVariables>({
        query: props.queryDocument,
        variables: props.queryVariables,
        fetchPolicy: 'no-cache',
      })
      .then((value) => {
        setLookups(props.extractLookups(value.data));
      });
  };

  useEffect(fetchLookups, [props.queryVariables]);

  const selectedLookups = lookups.filter((option) => {
    return (
      props.selectedValues?.length &&
      props.selectedValues?.indexOf(option.id) !== -1
    );
  });

  return <>{props.children({ lookups, selectedLookups })}</>;
};
